import React from 'react';

function AboutUsSection() {
  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-slate-800 tracking-tight">
            About Us
          </h2>
        </div>

        {/* Blue Banner Section */}
        <div className="relative mb-16 h-auto md:h-48 flex items-center justify-center">
          {/* Angled background effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-slate-400 to-slate-600 rounded-3xl transform -skew-y-1 rotate-1"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-slate-400 to-slate-600 rounded-3xl transform skew-y-1 -rotate-1"></div>

          {/* Inner content container, slightly smaller and centered */}
          <div className="relative z-10 bg-gradient-to-r from-blue-500 to-blue-600 rounded-3xl p-6 sm:p-8 md:p-10 w-full max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-start text-white text-center md:text-left shadow-xl">
            {/* Logo/Brand part */}
            <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-8">
              <span className="text-4xl sm:text-5xl font-bold leading-none block">MNR</span>
              <span className="text-4xl sm:text-5xl font-bold leading-none block">AI Worker</span>
              <span className="text-xl sm:text-2xl font-bold tracking-wider inline-block mt-1">Digital Employee</span>
            </div>

            {/* Text content */}
            <div className="flex-grow">
              <p className="text-lg sm:text-xl font-bold leading-relaxed mb-2">
                AI Worker - A Unique AI Platform for Creating Digital Employees.
              </p>
              <p className="text-base sm:text-lg leading-relaxed">
                We Help Entrepreneurs Worldwide Increase Profits and Save Time.
              </p>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 mt-12">
          {/* Left Column */}
          <div>
            <h3 className="text-lg font-bold text-cyan-500 mb-4">
              Founded by<br className="sm:hidden" /> MNR Technologies Global Pvt. Ltd.
            </h3>
            <div className="flex items-center text-slate-600 mb-8">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-lg font-medium">Since then, more than <span className="font-bold">500 users</span> have joined us.</p>
            </div>

            {/* Statistics Box */}
            <div className="relative bg-slate-800 text-white rounded-xl p-6 sm:p-8 shadow-lg overflow-hidden">
              <div className="relative z-10">
                <p className="text-xl sm:text-2xl font-bold leading-tight mb-4">
                  We use our <span className="text-cyan-400">own fine tune AI model</span> to handle robustly with <span className="text-cyan-400">minimal human intervention</span> which saves time and give best ROI.
                </p>
                {/* Decorative icons */}
                <div className="flex justify-end space-x-4 mt-6">
                  {/* Dollar icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-slate-600" fill="currentColor" viewBox="0 0 24 24" stroke="none">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.08V19h-2.82v-2.92A4.997 4.997 0 017 12c0-2.21 1.79-4 4-4h2c2.21 0 4 1.79 4 4a4.997 4.997 0 01-3.59 4.08zM12 10a2 2 0 100 4 2 2 0 000-4z" />
                  </svg>
                  {/* Clock icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-slate-600" fill="currentColor" viewBox="0 0 24 24" stroke="none">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.9 13H11V7h1.9v8z" />
                  </svg>
                </div>
              </div>
              <div className="absolute inset-0 bg-pattern opacity-10"></div>
            </div>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-slate-800 mb-4 leading-tight">
              How did the idea to create our own platform come about?
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6">
              We needed such a service ourselves, but there was no option on the market that met all the criteria (flexible pricing, functionality, integration with all messengers, data security, ease of use, and timely implementation)
            </p>
            <p className="text-slate-600 leading-relaxed">
              So, we decided to <span className="font-bold text-cyan-500">to develop our own platform.</span> Initially, it was used only by our team, but now it has grown into a large-scale project benefiting hundreds of people.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsSection;
